<div class="gradient {{class}}">
    <div class="container">
        <h4 class="mt-4 gradient-title" *ngIf="title">{{ title }}</h4>
        <ng-content></ng-content>
    </div>
</div>